import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class SelfCovered extends AbstractProductType {

  name = 'self_uncovered'
  title = 'Self Uncovered'

  format = ProductTypeFormat.Uncovered

}
